import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewTermsOfUseMutationVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
  text: Types.Scalars['String']['input'];
}>;


export type NewTermsOfUseMutation = { __typename?: 'Mutation', createTermsOfUse: { __typename?: 'TermsOfUse', id: string, uuid: string, updatedAt: number, text: string, membersAccepted: Array<{ __typename?: 'OrganisationMemberUser', id: string }> } };


export const NewTermsOfUseDocument = gql`
    mutation NewTermsOfUse($organisationUuid: String!, $text: String!) {
  createTermsOfUse(organisationUuid: $organisationUuid, text: $text) {
    id
    uuid
    updatedAt
    text
    membersAccepted {
      id
    }
  }
}
    `;
export type NewTermsOfUseMutationFn = Apollo.MutationFunction<NewTermsOfUseMutation, NewTermsOfUseMutationVariables>;

/**
 * __useNewTermsOfUseMutation__
 *
 * To run a mutation, you first call `useNewTermsOfUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewTermsOfUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newTermsOfUseMutation, { data, loading, error }] = useNewTermsOfUseMutation({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useNewTermsOfUseMutation(baseOptions?: Apollo.MutationHookOptions<NewTermsOfUseMutation, NewTermsOfUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewTermsOfUseMutation, NewTermsOfUseMutationVariables>(NewTermsOfUseDocument, options);
      }
export type NewTermsOfUseMutationHookResult = ReturnType<typeof useNewTermsOfUseMutation>;
export type NewTermsOfUseMutationResult = Apollo.MutationResult<NewTermsOfUseMutation>;
export type NewTermsOfUseMutationOptions = Apollo.BaseMutationOptions<NewTermsOfUseMutation, NewTermsOfUseMutationVariables>;